import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  JsonDecodingException1p97qvfqhd5n3 as JsonDecodingException,
  InvalidKeyKindException3b5w96w0jjxof as InvalidKeyKindException,
  InvalidFloatingPointDecoded2q5szzjempb3 as InvalidFloatingPointDecoded,
  minify1kh64osmcox7j as minify,
  JsonDecodingExceptiong65jdof8puc as JsonDecodingException_0,
} from './JsonExceptions.mjs';
import { NamedValueDecoderzk26ztf92xbq as NamedValueDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { classDiscriminator9fd3hvqsgfqq as classDiscriminator } from './Polymorphic.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull2liwjj96vm0w2 as JsonNull,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  JsonNull_getInstance3cean630pgfyb as JsonNull_getInstance,
  get_booleanOrNull376axlcpdhkmo as get_booleanOrNull,
  parseLongImpl2gkj8byk018b9 as parseLongImpl,
  get_float1xtaobzj8js8m as get_float,
  get_double1785hcxaminy4 as get_double,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonPrimitiveolttw629wj53 as JsonPrimitive_0,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  LIST_getInstance1utapkkkw66ts as LIST_getInstance,
  ENUM_getInstance2btpo8dvnibj3 as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstanceoecfbvb4e1b6 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { carrierDescriptor9eih94weel9f as carrierDescriptor } from './WriteMode.mjs';
import {
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  namingStrategy2xiv9qzked2jy as namingStrategy,
  deserializationNamesMap29c3n2byxqy5b as deserializationNamesMap,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
  get_JsonDeserializationNamesKey2d6gbfp1rff81 as get_JsonDeserializationNamesKey,
} from './JsonNamesMap.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { contains2c50nlxg7en7o as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { single29ec4rh52687r as single } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './StringJsonLexer.mjs';
import { JsonDecoderForUnsignedTypesaowwj2t4rf8t as JsonDecoderForUnsignedTypes } from './StreamingJsonDecoder.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import { get_schemaCache3drvxe6e7799s as get_schemaCache } from '../JsonSchemaCache.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new (JsonTreeDecoder())(_this__u8e3s4, element, discriminator, deserializer.x1m())).n1r(deserializer);
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.v2u(tag), toString($this.w2u()));
}
var AbstractJsonTreeDecoderClass;
function AbstractJsonTreeDecoder() {
  if (AbstractJsonTreeDecoderClass === VOID) {
    class $ extends NamedValueDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super();
        this.r2u_1 = json;
        this.s2u_1 = value;
        this.t2u_1 = polymorphicDiscriminator;
        this.u2u_1 = this.r2o().p2m_1;
      }
      r2o() {
        return this.r2u_1;
      }
      s3() {
        return this.s2u_1;
      }
      d1s() {
        return this.r2o().d1s();
      }
      w2u() {
        var tmp0_safe_receiver = this.c26();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.x2u(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.s3() : tmp1_elvis_lhs;
      }
      v2u(currentTag) {
        return this.e26() + ('.' + currentTag);
      }
      s2o() {
        return this.w2u();
      }
      n1r(deserializer) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var tmp;
          if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
            tmp = true;
          } else {
            tmp = this.r2o().p2m_1.i2o_1;
          }
          if (tmp) {
            tmp$ret$0 = deserializer.z1m(this);
            break $l$block;
          }
          var discriminator = classDiscriminator(deserializer.x1m(), this.r2o());
          var tmp0 = this.s2o();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = deserializer.x1m().a1o();
          if (!(tmp0 instanceof JsonObject())) {
            var tmp_0 = getKClass(JsonObject()).o1();
            var tmp_1 = getKClassFromExpression(tmp0).o1();
            var tmp$ret$1 = this.e26();
            throw JsonDecodingException(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
          }
          var jsonTree = tmp0;
          var tmp0_safe_receiver = jsonTree.w2o(discriminator);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_2;
          try {
            tmp_2 = findPolymorphicSerializer(deserializer, this, type);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof SerializationException()) {
              var it = $p;
              throw JsonDecodingException(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_4 = tmp_2;
          var actualSerializer = isInterface(tmp_4, DeserializationStrategy()) ? tmp_4 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.r2o(), discriminator, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      }
      d26(parentName, childName) {
        return childName;
      }
      o1r(descriptor) {
        var currentObject = this.w2u();
        var tmp0_subject = descriptor.t1p();
        var tmp;
        var tmp_0;
        if (equals(tmp0_subject, LIST_getInstance())) {
          tmp_0 = true;
        } else {
          tmp_0 = tmp0_subject instanceof PolymorphicKind();
        }
        if (tmp_0) {
          var tmp_1 = this.r2o();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = descriptor.a1o();
          if (!(currentObject instanceof JsonArray())) {
            var tmp_2 = getKClass(JsonArray()).o1();
            var tmp_3 = getKClassFromExpression(currentObject).o1();
            var tmp$ret$0 = this.e26();
            throw JsonDecodingException(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
          }
          tmp = new (JsonTreeListDecoder())(tmp_1, currentObject);
        } else {
          if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.r2o();
            var keyDescriptor = carrierDescriptor(descriptor.a1q(0), this_0.d1s());
            var keyKind = keyDescriptor.t1p();
            var tmp_4;
            var tmp_5;
            if (keyKind instanceof PrimitiveKind()) {
              tmp_5 = true;
            } else {
              tmp_5 = equals(keyKind, ENUM_getInstance());
            }
            if (tmp_5) {
              var tmp_6 = this.r2o();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName_0 = descriptor.a1o();
              if (!(currentObject instanceof JsonObject())) {
                var tmp_7 = getKClass(JsonObject()).o1();
                var tmp_8 = getKClassFromExpression(currentObject).o1();
                var tmp$ret$3 = this.e26();
                throw JsonDecodingException(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
              }
              tmp_4 = new (JsonTreeMapDecoder())(tmp_6, currentObject);
            } else {
              if (this_0.p2m_1.d2o_1) {
                var tmp_9 = this.r2o();
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
                // Inline function 'kotlinx.serialization.json.internal.cast' call
                var serialName_1 = descriptor.a1o();
                if (!(currentObject instanceof JsonArray())) {
                  var tmp_10 = getKClass(JsonArray()).o1();
                  var tmp_11 = getKClassFromExpression(currentObject).o1();
                  var tmp$ret$7 = this.e26();
                  throw JsonDecodingException(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
                }
                tmp_4 = new (JsonTreeListDecoder())(tmp_9, currentObject);
              } else {
                throw InvalidKeyKindException(keyDescriptor);
              }
            }
            tmp = tmp_4;
          } else {
            var tmp_12 = this.r2o();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_2 = descriptor.a1o();
            if (!(currentObject instanceof JsonObject())) {
              var tmp_13 = getKClass(JsonObject()).o1();
              var tmp_14 = getKClassFromExpression(currentObject).o1();
              var tmp$ret$12 = this.e26();
              throw JsonDecodingException(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
            }
            tmp = new (JsonTreeDecoder())(tmp_12, currentObject, this.t2u_1);
          }
        }
        return tmp;
      }
      p1r(descriptor) {
      }
      z1q() {
        var tmp = this.w2u();
        return !(tmp instanceof JsonNull());
      }
      y2u(tag, enumDescriptor) {
        var tmp = this.r2o();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
        var tmp2 = this.x2u(tag);
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = enumDescriptor.a1o();
        if (!(tmp2 instanceof JsonPrimitive())) {
          var tmp_0 = getKClass(JsonPrimitive()).o1();
          var tmp_1 = getKClassFromExpression(tmp2).o1();
          var tmp$ret$0 = this.v2u(tag);
          throw JsonDecodingException(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
        }
        return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.t2o());
      }
      q26(tag, enumDescriptor) {
        return this.y2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
      }
      z2u(tag) {
        return !(this.x2u(tag) === JsonNull_getInstance());
      }
      g26(tag) {
        return this.z2u((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      a2v(tag) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_booleanOrNull(literal);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$4 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$4;
      }
      h26(tag) {
        return this.a2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      b2v(tag) {
        var tmp$ret$5;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_1;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-128, 127);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_1 = convertToByte(result);
            } else {
              tmp_1 = null;
            }
            var tmp0_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }
            tmp$ret$5 = tmp_2;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$5;
      }
      i26(tag) {
        return this.b2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      c2v(tag) {
        var tmp$ret$5;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_1;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-32768, 32767);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_1 = convertToShort(result);
            } else {
              tmp_1 = null;
            }
            var tmp0_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }
            tmp$ret$5 = tmp_2;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$5;
      }
      j26(tag) {
        return this.c2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      d2v(tag) {
        var tmp$ret$5;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_1;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-2147483648, 2147483647);
            if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_1 = convertToInt(result);
            } else {
              tmp_1 = null;
            }
            var tmp0_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }
            tmp$ret$5 = tmp_2;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$5;
      }
      k26(tag) {
        return this.d2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      e2v(tag) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = parseLongImpl(literal);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$4 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$4;
      }
      l26(tag) {
        return this.e2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      f2v(tag) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_float(literal);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$4 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$4;
        var specialFp = this.r2o().p2m_1.k2o_1;
        if (specialFp || isFinite(result))
          return result;
        throw InvalidFloatingPointDecoded(result, tag, toString(this.w2u()));
      }
      m26(tag) {
        return this.f2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      g2v(tag) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_double(literal);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$4 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$4;
        var specialFp = this.r2o().p2m_1.k2o_1;
        if (specialFp || isFinite_0(result))
          return result;
        throw InvalidFloatingPointDecoded(result, tag, toString(this.w2u()));
      }
      n26(tag) {
        return this.g2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      h2v(tag) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.x2u(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp = getKClass(JsonPrimitive()).o1();
            var tmp_0 = getKClassFromExpression(value).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = new (Char())(single(literal.t2o()));
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$4 = tmp_1.j4_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$4;
      }
      o26(tag) {
        return this.h2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      i2v(tag) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var value = this.x2u(tag);
        if (!(value instanceof JsonPrimitive())) {
          var tmp = getKClass(JsonPrimitive()).o1();
          var tmp_0 = getKClassFromExpression(value).o1();
          var tmp$ret$0 = this.v2u(tag);
          throw JsonDecodingException(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
        }
        var value_0 = value;
        if (!(value_0 instanceof JsonLiteral()))
          throw JsonDecodingException(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.v2u(tag), toString(this.w2u()));
        if (!value_0.c2p_1 && !this.r2o().p2m_1.c2o_1) {
          throw JsonDecodingException(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.v2u(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.w2u()));
        }
        return value_0.e2p_1;
      }
      p26(tag) {
        return this.i2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      j2v(tag, inlineDescriptor) {
        var tmp;
        if (get_isUnsignedNumber(inlineDescriptor)) {
          var tmp_0 = this.r2o();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          var tmp2 = this.x2u(tag);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = inlineDescriptor.a1o();
          if (!(tmp2 instanceof JsonPrimitive())) {
            var tmp_1 = getKClass(JsonPrimitive()).o1();
            var tmp_2 = getKClassFromExpression(tmp2).o1();
            var tmp$ret$0 = this.v2u(tag);
            throw JsonDecodingException(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
          }
          var lexer = StringJsonLexer(tmp_0, tmp2.t2o());
          tmp = new (JsonDecoderForUnsignedTypes())(lexer, this.r2o());
        } else {
          tmp = super.r26(tag, inlineDescriptor);
        }
        return tmp;
      }
      r26(tag, inlineDescriptor) {
        return this.j2v((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
      }
      l1r(descriptor) {
        return !(this.c26() == null) ? super.l1r(descriptor) : (new (JsonPrimitiveDecoder())(this.r2o(), this.s3(), this.t2u_1)).l1r(descriptor);
      }
    }
    initMetadataForClass($, 'AbstractJsonTreeDecoder', VOID, VOID, [NamedValueDecoder(), JsonDecoder()]);
    AbstractJsonTreeDecoderClass = $;
  }
  return AbstractJsonTreeDecoderClass;
}
function setForceNull($this, descriptor, index) {
  $this.t2v_1 = (!$this.r2o().p2m_1.f2o_1 && !descriptor.b1q(index) && descriptor.a1q(index).m1p());
  return $this.t2v_1;
}
var JsonTreeDecoderClass;
function JsonTreeDecoder() {
  if (JsonTreeDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, polymorphicDiscriminator, polyDescriptor) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
        super(json, value, polymorphicDiscriminator);
        this.q2v_1 = value;
        this.r2v_1 = polyDescriptor;
        this.s2v_1 = 0;
        this.t2v_1 = false;
      }
      s3() {
        return this.q2v_1;
      }
      f1s(descriptor) {
        $l$loop: while (this.s2v_1 < descriptor.v1p()) {
          var _unary__edvuaz = this.s2v_1;
          this.s2v_1 = _unary__edvuaz + 1 | 0;
          var name = this.x25(descriptor, _unary__edvuaz);
          var index = this.s2v_1 - 1 | 0;
          this.t2v_1 = false;
          var tmp;
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          var this_0 = this.s3();
          if ((isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).x4(name)) {
            tmp = true;
          } else {
            tmp = setForceNull(this, descriptor, index);
          }
          if (tmp) {
            if (!this.u2u_1.h2o_1)
              return index;
            var tmp0 = this.r2o();
            var tmp$ret$3;
            $l$block_2: {
              // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
              var isOptional = descriptor.b1q(index);
              var elementDescriptor = descriptor.a1q(index);
              var tmp_0;
              if (isOptional && !elementDescriptor.m1p()) {
                var tmp_1 = this.u2v(name);
                tmp_0 = tmp_1 instanceof JsonNull();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$3 = true;
                break $l$block_2;
              }
              if (equals(elementDescriptor.t1p(), ENUM_getInstance())) {
                var tmp_2;
                if (elementDescriptor.m1p()) {
                  var tmp_3 = this.u2v(name);
                  tmp_2 = tmp_3 instanceof JsonNull();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$3 = false;
                  break $l$block_2;
                }
                var tmp_4 = this.u2v(name);
                var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive() ? tmp_4 : null;
                var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
                var tmp_5;
                if (tmp0_elvis_lhs == null) {
                  tmp$ret$3 = false;
                  break $l$block_2;
                } else {
                  tmp_5 = tmp0_elvis_lhs;
                }
                var enumValue = tmp_5;
                var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
                var coerceToNull = !tmp0.p2m_1.f2o_1 && elementDescriptor.m1p();
                if (enumIndex === -3 && (isOptional || coerceToNull)) {
                  if (setForceNull(this, descriptor, index))
                    return index;
                  tmp$ret$3 = true;
                  break $l$block_2;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3)
              continue $l$loop;
            return index;
          }
        }
        return -1;
      }
      z1q() {
        return !this.t2v_1 && super.z1q();
      }
      y25(descriptor, index) {
        var strategy = namingStrategy(descriptor, this.r2o());
        var baseName = descriptor.x1p(index);
        if (strategy == null) {
          if (!this.u2u_1.l2o_1)
            return baseName;
          if (this.s3().a5().y2(baseName))
            return baseName;
        }
        var deserializationNamesMap_0 = deserializationNamesMap(this.r2o(), descriptor);
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.s3().a5();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.u1();
          while (_iterator__ex2g4s.v1()) {
            var element = _iterator__ex2g4s.w1();
            if (deserializationNamesMap_0.z4(element) === index) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver;
        }
        var fallbackName = strategy == null ? null : strategy.i2s(descriptor, index, baseName);
        return fallbackName == null ? baseName : fallbackName;
      }
      x2u(tag) {
        return getValue(this.s3(), tag);
      }
      u2v(tag) {
        return this.s3().w2o(tag);
      }
      o1r(descriptor) {
        if (descriptor === this.r2v_1) {
          var tmp = this.r2o();
          var tmp2 = this.w2u();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = this.r2v_1.a1o();
          if (!(tmp2 instanceof JsonObject())) {
            var tmp_0 = getKClass(JsonObject()).o1();
            var tmp_1 = getKClassFromExpression(tmp2).o1();
            var tmp$ret$0 = this.e26();
            throw JsonDecodingException(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
          }
          return new (JsonTreeDecoder())(tmp, tmp2, this.t2u_1, this.r2v_1);
        }
        return super.o1r(descriptor);
      }
      p1r(descriptor) {
        var tmp;
        if (ignoreUnknownKeys(descriptor, this.r2o())) {
          tmp = true;
        } else {
          var tmp_0 = descriptor.t1p();
          tmp = tmp_0 instanceof PolymorphicKind();
        }
        if (tmp)
          return Unit_instance;
        var strategy = namingStrategy(descriptor, this.r2o());
        var tmp_1;
        if (strategy == null && !this.u2u_1.l2o_1) {
          tmp_1 = jsonCachedSerialNames(descriptor);
        } else if (!(strategy == null)) {
          tmp_1 = deserializationNamesMap(this.r2o(), descriptor).a5();
        } else {
          var tmp_2 = jsonCachedSerialNames(descriptor);
          var tmp0_safe_receiver = get_schemaCache(this.r2o()).u2t(descriptor, get_JsonDeserializationNamesKey());
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a5();
          var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
          tmp_1 = plus(tmp_2, tmp$ret$0);
        }
        var names = tmp_1;
        var _iterator__ex2g4s = this.s3().a5().u1();
        while (_iterator__ex2g4s.v1()) {
          var key = _iterator__ex2g4s.w1();
          if (!names.y2(key) && !(key === this.t2u_1)) {
            throw JsonDecodingException_0(-1, "Encountered an unknown key '" + key + "' at element: " + this.e26() + '\n' + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.s3().toString()))));
          }
        }
      }
    }
    initMetadataForClass($, 'JsonTreeDecoder');
    JsonTreeDecoderClass = $;
  }
  return JsonTreeDecoderClass;
}
var JsonTreeListDecoderClass;
function JsonTreeListDecoder() {
  if (JsonTreeListDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value) {
        super(json, value);
        this.b2w_1 = value;
        this.c2w_1 = this.b2w_1.v2();
        this.d2w_1 = -1;
      }
      s3() {
        return this.b2w_1;
      }
      y25(descriptor, index) {
        return index.toString();
      }
      x2u(tag) {
        return this.b2w_1.w2(toInt(tag));
      }
      f1s(descriptor) {
        while (this.d2w_1 < (this.c2w_1 - 1 | 0)) {
          this.d2w_1 = this.d2w_1 + 1 | 0;
          return this.d2w_1;
        }
        return -1;
      }
    }
    initMetadataForClass($, 'JsonTreeListDecoder');
    JsonTreeListDecoderClass = $;
  }
  return JsonTreeListDecoderClass;
}
var JsonPrimitiveDecoderClass;
function JsonPrimitiveDecoder() {
  if (JsonPrimitiveDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super(json, value, polymorphicDiscriminator);
        this.k2w_1 = value;
        this.s26('primitive');
      }
      s3() {
        return this.k2w_1;
      }
      f1s(descriptor) {
        return 0;
      }
      x2u(tag) {
        // Inline function 'kotlin.require' call
        if (!(tag === 'primitive')) {
          var message = "This input can only handle primitives with 'primitive' tag";
          throw IllegalArgumentException().s2(toString(message));
        }
        return this.k2w_1;
      }
    }
    initMetadataForClass($, 'JsonPrimitiveDecoder');
    JsonPrimitiveDecoderClass = $;
  }
  return JsonPrimitiveDecoderClass;
}
var JsonTreeMapDecoderClass;
function JsonTreeMapDecoder() {
  if (JsonTreeMapDecoderClass === VOID) {
    class $ extends JsonTreeDecoder() {
      constructor(json, value) {
        super(json, value);
        this.v2w_1 = value;
        this.w2w_1 = toList(this.v2w_1.a5());
        this.x2w_1 = imul(this.w2w_1.v2(), 2);
        this.y2w_1 = -1;
      }
      s3() {
        return this.v2w_1;
      }
      y25(descriptor, index) {
        var i = index / 2 | 0;
        return this.w2w_1.w2(i);
      }
      f1s(descriptor) {
        while (this.y2w_1 < (this.x2w_1 - 1 | 0)) {
          this.y2w_1 = this.y2w_1 + 1 | 0;
          return this.y2w_1;
        }
        return -1;
      }
      x2u(tag) {
        return (this.y2w_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.v2w_1, tag);
      }
      p1r(descriptor) {
      }
    }
    initMetadataForClass($, 'JsonTreeMapDecoder');
    JsonTreeMapDecoderClass = $;
  }
  return JsonTreeMapDecoderClass;
}
//region block: exports
export {
  readPolymorphicJson as readPolymorphicJson7wfdzotvo8aj,
};
//endregion

//# sourceMappingURL=TreeJsonDecoder.mjs.map
